// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"style_footerContainer__2kPSK","footer":"style_footer__3n-FN"};